var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:[
        'difference-icon-wrapper',
        { 'child-status-wrapper': _vm.isChildStatus, 'family-status-wrapper': _vm.isFamilyStatus, 'child-start-date-wrapper': _vm.isChildStartDate }
    ]},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
return [_c('font-awesome-icon',_vm._g({attrs:{"icon":"fa-solid fa-comment"}},on))]}}],null,false,2927014464)},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }